<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='card task-summary flat p-sm'>
  <div class='row pb-sm'>
    <div class='col-12 mb-md d-inline-flex space-between align-items-center'>
      <h3 class='mb-none'>Task #{{ task().series }}</h3>
      <div>
        <bs-button icon="fa-solid fa-arrow-up-right-from-square"
                  [rounded]='true'
                  [text]='true'
                  bsTooltip="{{translationSchema['dispatcher'].tasks.viewDetails | translate}}"
                  (click)='taskDetailsDialog.show(task())' data-testid="task-details-dialog-show-btn"/>
        @if (task()?.state?.canDelete) {
          <bs-button icon="fa-solid fa-trash"
                    [rounded]='true'
                    [text]='true'
                    bsTooltip="{{translationSchema['utils'].delete | translate}}"
                    (click)='deleteDialog.open(task().uuid!)' data-testid="on-delete-btn"/>
        }
        <button bsButton [text]="true" [rounded]="true"
                (click)="menu.toggle($event); $event.stopPropagation()" data-testid="menu-toggle-btn"><span class="ui-icon-more-vert" bsButtonIcon></span></button>

        <bs-popover #menu appendTo="body">
          <div class='row'>
            <div class='col-12'>
              <button bsButton
                      [text]="true"

                      [disabled]='!task()?.state?.canDoFullHandover'

                      (click)="fullHandoverDialog.open(task().uuid!); menu.hide(); $event.stopPropagation()" data-testid="on-full-handover-btn"><span class="fa-solid fa-check-double" bsButtonIcon></span><span bsButtonLabel>{{ translationSchema.task.list.fullHandover | translate }}</span></button>
            </div>
            <div class='col-12'>
              <button bsButton
                      [text]="true"

                      [disabled]='!task()?.state?.canClose'

                      (click)="closeDialog.open(task().uuid!); menu.hide(); $event.stopPropagation()" data-testid="on-close-btn"><span class="fa-solid fa-lock" bsButtonIcon></span><span bsButtonLabel>{{ translationSchema.task.list.closeTask | translate }}</span></button>
            </div>
          </div>
        </bs-popover>
      </div>
    </div>

    <div class='col-12 mb-md'>
      <div class='row mb-sm'>
        <div class='col-12'>
          <h2
            class='my color-primary bold my-none'>{{ 'task.statusEnum.' + task().status | translate }}</h2>
        </div>

        <div class='col-12 status-sub-data'>
          <span class='bold pr-sm gray'>{{ translationSchema['dispatcher'].tasks.updatedAt | translate }}: {{ task().lastModifiedAt | wellDate:'yyyy-MM-dd' }}</span>
          <span>{{ task().lastModifiedAt | wellDate:'HH:mm' }}</span>
        </div>
      </div>

      <div class=''>
        <div class='checkpoint'>
          <div class='col-12 d-inline-flex align-items-center space-between'>
            <h4> {{ translationSchema['delivery-app'].utils.pickup | translate | uppercase }} </h4>
            @if (task().pickupCheckpoint?.state?.canHandover) {
              <bs-button icon='fa-solid fa-pen-to-square'
                        [rounded]='true'
                        [text]='true'
                        bsTooltip="{{translationSchema['dispatcher'].tasks.changeStatus | translate}}"
                        (click)='onTaskCheckpointChangeStatus(task().pickupCheckpoint?.uuid!)' data-testid="on-task-checkpoint-change-status-btn"/>
            }
          </div>
          <well-task-card-checkpoint [location]='sourceLocation()'
                                     [namedLocationCode]='task().pickupCheckpoint?.namedLocationCode'
                                     [namedLocationLabel]='task().pickupCheckpoint?.namedLocationLabel'
                                     [timeWindowStart]='task().pickupCheckpoint?.timeWindowStart'
                                     [timeWindowEnd]='task().pickupCheckpoint?.timeWindowEnd'></well-task-card-checkpoint>
        </div>
        @for (deliveryTask of destLocation(); track deliveryTask; let index = $index) {

          <div class='checkpoint'>
            <div class='col-12 d-inline-flex align-items-center space-between'>
              <h4> {{ translationSchema['delivery-app'].utils.delivery | translate | uppercase }} {{ destLocation().length > 1 ? index + 1 : '' }}</h4>
              <div>
                @if (deliveryTask?.state?.canHandover) {
                  <bs-button icon='fa-solid fa-pen-to-square'
                            [rounded]='true'
                            [text]='true'
                            bsTooltip="{{translationSchema['dispatcher'].tasks.changeStatus | translate}}"
                            (click)='onTaskCheckpointChangeStatus(deliveryTask.uuid)' data-testid="on-task-checkpoint-change-status-btn-2"/>
                }
                @if (deliveryTask?.state?.canReturn) {
                  <bs-button icon='fa-solid fa-house-flag'
                            [rounded]='true'
                            [text]='true'
                            bsTooltip="{{translationSchema['dispatcher'].tasks.unavailableDelivery | translate}}"
                            (click)='onUnavailableDelivery(deliveryTask.uuid)' data-testid="on-unavailable-delivery-btn"/>
                }
              </div>
            </div>
            <well-task-card-checkpoint [location]='deliveryTask.location'
                                       [namedLocationCode]='deliveryTask.namedLocationCode'
                                       [namedLocationLabel]='deliveryTask.namedLocationLabel'
                                       [timeWindowStart]='deliveryTask.timeWindowStart'
                                       [timeWindowEnd]='deliveryTask.timeWindowEnd'></well-task-card-checkpoint>
          </div>
        }

        @if (task().returnCheckpoint) {
          <div class='checkpoint'>
            <div class='col-12 d-inline-flex align-items-center space-between'>
              <h4> {{ translationSchema['delivery-app'].utils.return | translate | uppercase }}</h4>
              @if (task().returnCheckpoint?.state?.canHandover) {
                <bs-button icon='fa-solid fa-pen-to-square'
                          [rounded]='true'
                          [text]='true'
                          bsTooltip="{{translationSchema['dispatcher'].tasks.changeStatus | translate}}"
                          (click)='onTaskCheckpointChangeStatus(task().returnCheckpoint?.uuid!)' data-testid="on-task-checkpoint-change-status-btn-3"/>
              }
            </div>
            <well-task-card-checkpoint [location]='returnLocation()?.location'
                                       [namedLocationCode]='returnLocation()?.namedLocationCode'
                                       [namedLocationLabel]='returnLocation()?.namedLocationLabel'
                                       [timeWindowStart]='returnLocation()?.timeWindowStart'
                                       [timeWindowEnd]='returnLocation()?.timeWindowEnd'></well-task-card-checkpoint>
          </div>
        }
      </div>
      <well-task-card-summary-details
        [task]='task()'>
      </well-task-card-summary-details>
    </div>
  </div>
</div>

<well-task-details-dialog #taskDetailsDialog></well-task-details-dialog>
<well-task-delete-dialog #deleteDialog (deleted)='onTaskDeleted()' (solutionDeleted)='onSolutionDeleted()' />
<well-task-close-dialog #closeDialog (closed)='onTaskClosed()' />
<well-task-full-handover-dialog #fullHandoverDialog (handoverCompleted)='onTaskHandoverFull()' />


